import { render, staticRenderFns } from "./WalletUpdatePoint.vue?vue&type=template&id=3dcbc3de&scoped=true&"
import script from "./WalletUpdatePoint.vue?vue&type=script&lang=js&"
export * from "./WalletUpdatePoint.vue?vue&type=script&lang=js&"
import style0 from "./WalletUpdatePoint.vue?vue&type=style&index=0&id=3dcbc3de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcbc3de",
  null
  
)

export default component.exports